import React from 'react';
import '../styles/loading.css';

export const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner" />
      <p>Loading...</p>
    </div>
  );
};

export const LoadingOverlay = ({ visible = false }) => {
  if (!visible) return null;
  
  return (
    <div className="loading-overlay">
      <div className="spinner" />
    </div>
  );
};
